export const collapse = function (element) {
    // get the height of the element's inner content, regardless of its actual size
    const height = element.scrollHeight;

    // temporarily disable all css transitions
    const elementTransition = element.style.transition;
    element.style.transition = '';

    // on the next frame (as soon as the previous style change has taken effect),
    // explicitly set the element's height to its current pixel height, so we
    // aren't transitioning out of 'auto'
    requestAnimationFrame(function () {
        element.style.transition = elementTransition;
        element.classList.add('transitioning');
        element.style.height = `${height}px`;

        // on the next frame (as soon as the previous style change has taken effect),
        // have the element transition to height: 0
        requestAnimationFrame(function () {
            element.style.height = '0px';
        });
    });

    // when the next css transition finishes (which should be the one we just triggered)
    element.addEventListener('transitionend', function removeCollapseTransitionStyles(e) {
        // remove this event listener so it only gets triggered once
        element.removeEventListener('transitionend', removeCollapseTransitionStyles);

        // remove "transitioning" class from element, so it can return to its initial value
        element.style.height = null;
        element.classList.remove('transitioning');
    });
};

export const expand = function expandSection(element) {
    // have the element transition to the height of its inner content
    element.style.height = '0px';
    element.classList.add('transitioning');

    requestAnimationFrame(function () {
        // get the height of the element's inner content, regardless of its actual size
        const height = element.scrollHeight;
        element.style.height = `${height}px`;
    });

    // when the next css transition finishes (which should be the one we just triggered)
    element.addEventListener('transitionend', function removeExpandTransitionStyles(e) {
        // remove this event listener so it only gets triggered once
        element.removeEventListener('transitionend', removeExpandTransitionStyles);

        // remove "height" from the element's inline styles, so it can return to its initial value
        element.style.height = null;
        element.classList.remove('transitioning');
    });
};
